import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SlTypographyComponent } from '../sl-typography/sl-typography.component';
@Component({
  selector: 'sl-radio-button',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SlTypographyComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './sl-radio-button.component.html',
  styleUrl: './sl-radio-button.component.scss',
})
export class SlRadioButtonComponent<T> {
  @Input() options: { name: string; value: T }[] = [];
  @Input() label!: string;
  @Input() required = false;
  @Input() disabled = false;
  @Input() control: FormControl = new FormControl({
    value: undefined,
    disabled: true,
  });
  @Output() clickEvent: EventEmitter<T> = new EventEmitter<T>();

  onClickRadioButton(value: T) {
    this.clickEvent.emit(value);
  }
}
